 document.addEventListener("DOMContentLoaded", () => {
    const gallery = document.querySelector(".product-gallery");
    if (!gallery) return;

    const thumbnails = Array.from(
      gallery.querySelectorAll(".product-gallery--media-thumbnail")
    );
    const prevBtn = gallery.querySelector(".gallery-navigation--scroll-button.scroll-left");
    const nextBtn = gallery.querySelector(".gallery-navigation--scroll-button.scroll-right");

    if (!thumbnails.length || !prevBtn || !nextBtn) return;

    const getCurrentIndex = () =>
      thumbnails.findIndex((thumb) =>
        thumb.getAttribute("data-gallery-selected") === "true"
      );
    const activateThumbnail = (index) => {
      if (index < 0 || index >= thumbnails.length) return;
      thumbnails[index].click();
    };

    prevBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const currentIndex = getCurrentIndex();
      const newIndex = (currentIndex - 1 + thumbnails.length) % thumbnails.length;
      activateThumbnail(newIndex);
    });

    nextBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const currentIndex = getCurrentIndex();
      const newIndex = (currentIndex + 1) % thumbnails.length;
      activateThumbnail(newIndex);
    });
});